/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Delete_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Delete latest commit?" |
*
* @param {Snapshot_History_Delete_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_delete_confirm_title = /** @type {((inputs?: Snapshot_History_Delete_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Delete_Confirm_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Delete latest commit?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Delete latest commit?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Delete latest commit?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Delete latest commit?")
	if (locale === "es") return /** @type {LocalizedString} */ ("Delete latest commit?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Delete latest commit?")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Delete latest commit?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Delete latest commit?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Delete latest commit?")
	return /** @type {LocalizedString} */ ("Delete latest commit?")
});